import { Box, Button, Typography } from "@mui/material";
import { Description } from "@mui/icons-material";
import { useStore } from "../../../store/store";
import { fetchOwnPayslip } from "../utils/staffPayApi";
import { OwnPayslip } from "../types";

type OwnPayslipFilesProps = {
    payslips: Array<OwnPayslip>;
};

const PAYSLIP_URL_LIFETIME_MILLISECONDS = 60 * 1000;
const PAYSLIP_FALLBACK_NAME = "Recibo";

const showPayslip = (payslipTab: Window | null, payslipUrl: string, payslipName: string) => {
    if (payslipTab) {
        payslipTab.location.href = payslipUrl;
        return;
    }
    const downloadLink = document.createElement("a");
    downloadLink.href = payslipUrl;
    downloadLink.download = payslipName;
    downloadLink.click();
};

export const OwnPayslipFiles = ({ payslips }: OwnPayslipFilesProps) => {
    const { notifications } = useStore();

    const openPayslip = async (payslip: OwnPayslip) => {
        const payslipTab = window.open("", "_blank");
        try {
            const payslipBlob = await fetchOwnPayslip(payslip.id);
            const payslipUrl = URL.createObjectURL(new Blob([payslipBlob], { type: payslip.type }));
            showPayslip(payslipTab, payslipUrl, payslip.filename_download ?? PAYSLIP_FALLBACK_NAME);
            setTimeout(() => URL.revokeObjectURL(payslipUrl), PAYSLIP_URL_LIFETIME_MILLISECONDS);
        } catch {
            payslipTab?.close();
            notifications.setNotification({ isOpen: true, message: "Não foi possível abrir o recibo.", severity: "error" });
        }
    };

    if (payslips.length === 0) {
        return null;
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 0.5 }}>
            <Typography variant="body1">Recibos</Typography>
            {payslips.map((payslip) => (
                <Button key={payslip.id} variant="text" size="small" startIcon={<Description />} onClick={() => openPayslip(payslip)}>
                    {payslip.filename_download ?? PAYSLIP_FALLBACK_NAME}
                </Button>
            ))}
        </Box>
    );
};
